import {
  type SearchSuggestion,
  type SearchSuggestionType,
  type SearchParams,
  type SearchResponseDto,
} from '@ra-mr/types';

export { type SearchSuggestion, type SearchSuggestionType, type SearchParams };
export type DetailedSearchResult = SearchResponseDto;

const API_URL = process.env.API_URL || 'http://localhost:3000/api';

const fetchSearch = async (
  url: string,
  params: SearchParams,
  signal?: AbortSignal
): Promise<DetailedSearchResult> => {
  const query = new URLSearchParams({ q: params.q });
  if (params.limit) {
    query.set('limit', String(params.limit));
  }

  try {
    const response = await fetch(`${url}/public/search?${query}`, { cache: 'no-store', signal });
    if (!response.ok) {
      return { status: 'error', suggestions: [] };
    }
    const data: SearchResponseDto = await response.json();
    return {
      suggestions: data.suggestions || [],
      status: data.status || 'success',
    };
  } catch (error) {
    if (signal?.aborted) {
      throw error;
    }
    return { status: 'error', suggestions: [] };
  }
};

export const search = async (params: SearchParams): Promise<SearchSuggestion[]> => {
  return (await fetchSearch(API_URL, params)).suggestions;
};

export const searchClientDetailed = async (params: SearchParams, signal?: AbortSignal): Promise<DetailedSearchResult> => {
  return fetchSearch('/api', params, signal);
};

export const searchClient = async (params: SearchParams): Promise<SearchSuggestion[]> => {
  return (await searchClientDetailed(params)).suggestions;
};
